
import { useEffect } from 'react'
import Select from 'react-select'
import { WTPEquipmentTypeDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const WTPEquipmentTypeDDLData = (props) => {
    const { WtpEquipmentType, setWtpEquipmentType, WardName, PopUpField, rowData, Flag,IsDisabled } = props

    // console.log(rowData)

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { UserID, token }
        dispatch(WTPEquipmentTypeDDLAPI({ data }))
    }, [])

    const { WTPEquipmentTypeData } = useSelector(state => state.WTPEquipmentTypeDDLData)

    useEffect(() => {
        handleWtpEquipmentTypeDDL()
    }, [WTPEquipmentTypeData])

    const handleWtpEquipmentTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPEquipmentTypeData && WTPEquipmentTypeData.table && WTPEquipmentTypeData.table.length > 0) {
            let list = WTPEquipmentTypeData.table.map((item, index) => ({
                value: item.m_wtP_EquipmentTypeID,
                label: item.equipmentType,
            }))

            setWtpEquipmentType({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_wtP_EquipmentTypeID : 0,
                Label: Flag === 'Update' ? rowData.equipmentType : "Select...",
            })
        }
        else {
            setWtpEquipmentType({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Equipment Type</b></label>
        <Select
            // isClearable
            // isRtl={isRtl}
            // className="ddl_width"
            isDisabled={IsDisabled}
            isSearchable
            maxMenuHeight={150}
            value={{ value: WtpEquipmentType.ID, label: WtpEquipmentType.Label }}
            onChange={(e) => {
                e ?
                    setWtpEquipmentType({ ...WtpEquipmentType, ID: e.value, Label: e.label })
                    :
                    setWtpEquipmentType({ ...WtpEquipmentType, ID: 0, Label: "Select..." })

            }}
            options={WtpEquipmentType.DDL}
        />

    </div>

    )
}